import { combineReducers } from 'redux';
import {
    REQUEST_FORM_SUBMIT_PAYMENT,
    SUCCESS_FORM_SUBMIT_PAYMENT,
    FAILURE_FORM_SUBMIT_PAYMENT,
    SUCCESS_EBON_FORM_SUBMIT_PAYMENT,
    REQUEST_EBON_FORM_SUBMIT_PAYMENT,
    FAILURE_EBON_FORM_SUBMIT_PAYMENT
} from './constants';

/*
 * State shape
{
    success : false,
    requesting: false,
    error: ''
}
*/

const requesting = (state = false, action) => {
    switch (action.type) {
        case REQUEST_FORM_SUBMIT_PAYMENT:
            return true;
        case SUCCESS_FORM_SUBMIT_PAYMENT:
        case FAILURE_FORM_SUBMIT_PAYMENT:
            return false;
        default:
            return state;
    }
};

const success = (state = false, action) => {
    switch (action.type) {
        case SUCCESS_FORM_SUBMIT_PAYMENT:
            return true;
        case REQUEST_FORM_SUBMIT_PAYMENT:
        case FAILURE_FORM_SUBMIT_PAYMENT:
            return false;
        default:
            return state;
    }
};

const error = (state = '', action) => {
    switch (action.type) {
        case FAILURE_FORM_SUBMIT_PAYMENT:
            return action.response.message;
        case SUCCESS_FORM_SUBMIT_PAYMENT:
        case REQUEST_FORM_SUBMIT_PAYMENT:
            return '';
        default:
            return state;
    }
};
const requestingEbon = (state = false, action) => {
    switch (action.type) {
        case REQUEST_EBON_FORM_SUBMIT_PAYMENT:
            return true;
        case SUCCESS_EBON_FORM_SUBMIT_PAYMENT:
        case FAILURE_EBON_FORM_SUBMIT_PAYMENT:
            return false;
        default:
            return state;
    }
};

const successEbon = (state = false, action) => {
    switch (action.type) {
        case SUCCESS_EBON_FORM_SUBMIT_PAYMENT:
            return true;
        case REQUEST_EBON_FORM_SUBMIT_PAYMENT:
        case FAILURE_EBON_FORM_SUBMIT_PAYMENT:
            return false;
        default:
            return state;
    }
};

const errorEbon = (state = '', action) => {
    switch (action.type) {
        case FAILURE_EBON_FORM_SUBMIT_PAYMENT:
            return action.response.message;
        case SUCCESS_EBON_FORM_SUBMIT_PAYMENT:
        case REQUEST_EBON_FORM_SUBMIT_PAYMENT:
            return '';
        default:
            return state;
    }
};
export default combineReducers({
    requesting,
    success,
    error,
    requestingEbon,
    successEbon,
    errorEbon
});



// WEBPACK FOOTER //
// ./src/services/account/paymentrequest/request/reducer.js